import { AfterViewInit, Directive, ElementRef, inject, input } from '@angular/core';

export const AutoCompleteFormControlDirectiveInputs = [
  'dropdown',
  'field',
  'optionValue',
  'dataKey',
  'autoHighlight',
  'minSearchLength',
  'maxLength',
  'forceSelection',
  'showClear',
  'appendTo',
  'multiple',
  'optionLabel',
];

@Directive({
  selector: '[uiAutoCompleteFormControl]',
  standalone: true,
})
export class AutoCompleteFormControlDirective implements AfterViewInit {
  private el = inject(ElementRef);

  readonly dropdown = input(false);

  readonly field = input<string | null>('label');

  readonly optionValue = input<string>('');

  readonly dataKey = input<string | null>(null);

  readonly autoHighlight = input(false);

  readonly minSearchLength = input(4);

  readonly maxLength = input<number | null>(null);

  readonly forceSelection = input(false);

  readonly showClear = input(true);

  readonly appendTo = input<string | null>(null);

  readonly multiple = input<boolean>(false);

  readonly optionLabel = input<string | ((item: any) => string)>();

  ngAfterViewInit() {
    const inputElement: HTMLInputElement = this.el.nativeElement.querySelector('input');
    const maxLength = this.maxLength();
    if (inputElement && maxLength) {
      inputElement.setAttribute('maxlength', maxLength.toString());
    }
  }
}
